import { Box } from "@mui/material";
import React, { Suspense } from "react";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/_index.scss";
import { ConsentProvider } from "./context/ConsentContext";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);
root.render(
    <BrowserRouter basename="/">
        <ConsentProvider>
            <Suspense
                fallback={
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "40px 0",
                            height: "100vh",
                        }}
                    >
                        <div className="loader"></div>
                    </Box>
                }
            >
                <App />
            </Suspense>
        </ConsentProvider>
    </BrowserRouter>
);
